{
  "version": 1,
  "asset_id": "a996817f-fa2f-4141-a4e6-7d3bcb5b9fa9",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a996817f-fa2f-4141-a4e6-7d3bcb5b9fa9/texas-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a996817f-fa2f-4141-a4e6-7d3bcb5b9fa9/texas-640.webp",
  "original_filename": "texas-640.webp",
  "size": 15192,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:05Z"
}
